import { Box } from '@mui/material';
import { FlexBox } from '../flex-box';
import BazaarRating from '../BazaarRating';
import { H5, H6, Paragraph } from '../Typography';

const ProductComment = (props) => {
  const { title, reviewer, rating, review_date, details, store } = props;
  return (
    <Box mb={4}>
      <FlexBox alignItems="center" mb={2}>
        <Box>
          <H5 mb={0.5}>{title}</H5>
          <FlexBox alignItems="center">
            <BazaarRating value={Number(rating)} color="warn" readOnly mr={1} />
            <Box>{review_date}</Box>
            <H6 mx={1.25}>{reviewer}</H6>
            <Paragraph>originally posted on {store}</Paragraph>
          </FlexBox>
        </Box>
      </FlexBox>

      <Paragraph color="grey.700" truncate={4}>{details}</Paragraph>
    </Box>
  );
};
export default ProductComment;
